import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';

# Assign/Swap Channel

## <v-icon>mdi-arrow-right-bottom</v-icon>/<v-icon>mdi-swap-horizontal</v-icon> Assign/Swap Channel

Select the Channel you wish to assign, then click <v-btn prepend-icon='mdi-arrow-right-bottom' color='primary'>ASSIGN</v-btn>

## <v-icon>mdi-plus</v-icon> Create New Channel to Assign/Swap to

Enter a Channel Name and a Channel Description for the new Channel then click <v-btn prepend-icon='mdi-plus' color='primary'>CREATE & ASSIGN</v-btn>

## Cancelling

To cancel your changes click <ExampleCloseButton /> (top right).
